import type { Accessory } from '$lib/types'

export const DEFAULT_HEAD = 'headband'
export const DEFAULT_BODY = 't-shirt'
export const DEFAULT_POSE = 'default'

export type Rarity = 'common' | 'rare' | 'epic' | 'legendary' | 'sponsored'

export const getRarity = (accessory: Accessory | undefined) => {
  if (!accessory) return 'common'
  if (accessory.sponsor_organization_id) {
    return 'sponsored'
  } else {
    switch (accessory.rarity) {
      case 0:
      case 1:
        return 'common'
      case 2:
        return 'rare'
      case 3:
        return 'epic'
      default:
        return 'legendary'
    }
  }
}
